import { Button, Modal } from "@mantine/core";

import { useState, useEffect } from "react";

type Props = {
  showActionButtons?: boolean;
  title: string;
  content: React.ReactNode;
  showModal: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  confirmButtonText?: string;
  cancelButtonLink?: string;
  size?: string;
};

const ConfirmationModal = ({
  showActionButtons = true,
  title,
  content,
  showModal,
  onClose,
  onConfirm,
  confirmButtonText = "Confirm",
  cancelButtonLink = "Cancel",
  size,
}: Props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const confirm = async () => {
    setIsButtonDisabled(true);

    await onConfirm();
    setIsButtonDisabled(false);
  };
  useEffect(() => {
    console.log("isButtonDisabled", isButtonDisabled);
  }, [isButtonDisabled]);
  return (
    <Modal
      opened={showModal}
      onClose={onClose}
      centered
      size={size}
      overflow="inside"
      title={title}
    >
      <div className="pb-4 px-2">{content}</div>
      {showActionButtons && (
        <div className="fixed-bottom bg-white py-2 px-3">
          <Button
            color={"pink"}
            radius="md"
            variant="light"
            onClick={() => {
              onClose();
            }}
          >
            {cancelButtonLink}
          </Button>
          <Button
            className="ms-2"
            radius="md"
            variant="light"
            disabled={isButtonDisabled}
            onClick={confirm}
          >
            {confirmButtonText}
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmationModal;
